// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { Button } from 'moods-react/Button';

import startedTip1Image from '../../../assets/full-upload/get-started-1.png';
import startedTip2Image from '../../../assets/full-upload/get-started-2.png';
import startedTip3Image from '../../../assets/full-upload/get-started-3.png';

import GuaranteeIcon from '../../../common/icons/guarantee/GuaranteeComponent';
import GettingStartedItem from './getting-started-item/GettingStartedItemComponent';
import GettingStartedCaption from './getting-started-caption/GettingStartedCaptionComponent';

import messages from '../../../../data/full-upload';
import { envUrl } from '../../../services/environment/EnvironmentService';

import './GettingStarted.scss';

const GettingStartedComponent = (
  props: {
    config: { selectedLocale: string },
    getStartedCallback: Function,
    guidelinesCallback: Function,
    history: Function,
  },
  context: { intl: Object },
) => {
  function onNextPage(): void {
    props.getStartedCallback();
    props.history.push(envUrl('/products/upload'));
  }

  const currentLocale = props.config.selectedLocale;
  const text = context.intl.formatMessage;

  return (
    <div className="getting-started-component u-fontFamily-primaryMedium">
      <div className="getting-started-component__inner-container">
        <div className="getting-started-component__title u-fontFamily-primaryMedium">
          <FormattedMessage
            id="app.fullUpload.started.title"
            defaultMessage="Getting started uploading a perfect design"
          />
        </div>
        <div className="getting-started-component__subtitle u-fontFamily-secondary">
          <FormattedMessage id="app.fullUpload.started.subtitle" defaultMessage="Tips for perfect printing" />
        </div>

        <section className="getting-started-component__container u-display-flex@medium">
          <GettingStartedItem imgAlt="Artwork guidelines" imgSrc={startedTip1Image}>
            <GettingStartedCaption title={text(messages.tip1Title)} text={text(messages.tip1Text)}>
              <a
                className="getting-started-component__link"
                target="_blank"
                href={`https://support.moo.com/hc/${currentLocale}/sections/200570950-MOO-Product-Templates`}
                rel="noopener noreferrer"
                onClick={props.guidelinesCallback}
              >
                <FormattedMessage
                  id="app.fullUpload.started.guidelines.link"
                  defaultMessage="Artwork Guidelines & Templates."
                />
              </a>
            </GettingStartedCaption>
          </GettingStartedItem>
          <GettingStartedItem imgAlt="Crop marks" imgSrc={startedTip2Image}>
            <GettingStartedCaption title={text(messages.tip2Title)} text={text(messages.tip2Text)} />
          </GettingStartedItem>
          <GettingStartedItem imgAlt="Export files" imgSrc={startedTip3Image}>
            <GettingStartedCaption title={text(messages.tip3Title)} text={text(messages.tip3Text)} />
          </GettingStartedItem>
        </section>
        <span className="getting-started-component__button">
          {/* eslint-disable-next-line react/jsx-no-bind */}
          <Button onClick={onNextPage}>{text(messages.getStartedButtonText)}</Button>
        </span>
        <div className="getting-started-component__moo-promise">
          <div className="getting-started-component__moo-promise-container">
            <div className="getting-started-component__moo-promise-icon">
              <GuaranteeIcon />
            </div>
            <div className="getting-started-component__moo-promise-summary">
              <div className="getting-started-component__moo-promise-title">
                <FormattedMessage id="app.fullUpload.started.footer.title" defaultMessage="The MOO Promise" />
              </div>
              <p className="getting-started-component__moo-promise-text">
                <FormattedMessage
                  id="app.fullUpload.started.footer.text"
                  defaultMessage="We take great pride in our work. So even for the tiniest of typos, we'll move heaven and earth to make sure you get exactly what you want."
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

GettingStartedComponent.displayName = 'GettingStarted';

GettingStartedComponent.propTypes = {
  config: PropTypes.shape({
    selectedLocale: PropTypes.string.isRequired,
  }).isRequired,
  getStartedCallback: PropTypes.func.isRequired,
  guidelinesCallback: PropTypes.func.isRequired,
};

GettingStartedComponent.contextTypes = {
  intl: intlShape.isRequired,
};

export default withRouter(GettingStartedComponent);
